<template>
	<div id="Main">
		<p class="title">{{title}}</p>
		<p class="textp" v-html="html"></p>
		<van-checkbox v-model="checked" class="checkbox"><span class="label">本人已阅读并同意签署<span class="a">《{{title}}》</span>，同意报送托管服务相关信息至信息基础数据库</span></van-checkbox>
		<van-button round type="info" class="button" @click="sure">确 定</van-button>
	</div>
</template>
<script>
	import axiosPost from '../../libs/moudle/index.js';
	export default {
		components: {},
		data() {
			return {
				checked: '',
				phone:'',
				title:'',
				html:'',
				openId:''
			}
		},
		methods: {
			sure() {
				if (this.checked) {
					this.$router.push({
						path: '/identity',
						query:{
							phone:this.phone,
							openId:this.openId
						}
					})
				} else {
					this.$toast({duration:4000,message:'请选择并同意《'+this.title+'》'});
				}
			},
			getfile(){
				axiosPost.getfile({id:14}).then((res) => {
					window.console.log(res.data)
					if (res.data.code == 1) {
						this.title=res.data.data.title
						this.html=res.data.data.content
					} else {
						window.console.log(res.data.msg)
					}
				}).catch((res) => {
					window.console.log(res)
				})
			}
		},
		mounted(){
			this.phone = this.$route.query.phone
			this.openId=this.$route.query.openId
			this.getfile();
		}
	}
</script>

<style lang="scss" scoped>
	#Main {
		padding: 1.3rem;
		text-align: left;

		.title {
			font-size: 2rem;
			text-align: center;
			color: #666666;
			padding: 2rem 0;
			font-weight: bold;
		}

		.textp {
			font-size: 1.4rem;
			line-height: 2.4rem;
			color: #666666;
			padding-bottom: 0.4rem;
		}

		.texttitle {
			font-size: 1.4rem;
			line-height: 2.4rem;
			color: #666666;
			font-weight: bold;
			padding-bottom: 0.4rem;
		}

		.checkbox {
			padding: 1rem 0;
			font-size: 1.3rem;
			color: #999999;

			.label {
				color: #999999;
			}

			.a {
				color: #17b0fc;
			}
		}

		.button {
			width: 100%;
			background-color: #fa6b6b;
			border: 0;
			font-size: 2rem;
			margin: 1rem 0;
		}
	}
</style>
